import React from "react";

export default function PriceMatrixIcon() {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.25 19.2583C7.58561 19.254 12.898 19.9605 18.047 21.3593C18.774 21.5573 19.5 21.0173 19.5 20.2633V19.2583M3.75 5.0083V5.7583C3.75 5.95721 3.67098 6.14798 3.53033 6.28863C3.38968 6.42928 3.19891 6.5083 3 6.5083H2.25M2.25 6.5083V6.1333C2.25 5.5123 2.754 5.0083 3.375 5.0083H20.25M2.25 6.5083V15.5083M20.25 5.0083V5.7583C20.25 6.1723 20.586 6.5083 21 6.5083H21.75M20.25 5.0083H20.625C21.246 5.0083 21.75 5.5123 21.75 6.1333V15.8833C21.75 16.5043 21.246 17.0083 20.625 17.0083H20.25M2.25 15.5083V15.8833C2.25 16.1817 2.36853 16.4678 2.5795 16.6788C2.79048 16.8898 3.07663 17.0083 3.375 17.0083H3.75M2.25 15.5083H3C3.19891 15.5083 3.38968 15.5873 3.53033 15.728C3.67098 15.8686 3.75 16.0594 3.75 16.2583V17.0083M20.25 17.0083V16.2583C20.25 16.0594 20.329 15.8686 20.4697 15.728C20.6103 15.5873 20.8011 15.5083 21 15.5083H21.75M20.25 17.0083H3.75M15 11.0083C15 11.804 14.6839 12.567 14.1213 13.1296C13.5587 13.6922 12.7956 14.0083 12 14.0083C11.2044 14.0083 10.4413 13.6922 9.87868 13.1296C9.31607 12.567 9 11.804 9 11.0083C9 10.2127 9.31607 9.44959 9.87868 8.88698C10.4413 8.32437 11.2044 8.0083 12 8.0083C12.7956 8.0083 13.5587 8.32437 14.1213 8.88698C14.6839 9.44959 15 10.2127 15 11.0083ZM18 11.0083H18.008V11.0163H18V11.0083ZM6 11.0083H6.008V11.0163H6V11.0083Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
